import { UsageEventProductMappingsService } from '../../services/usageEventProductMappings/usageEventProductMappings.service';
import { VariantService } from '../../services/variant/variant.service';
import { ProductService } from '../../services/product/product.service';
import { PaymentService } from '../../services/payments/payments.service';
import { UserMessagesService } from '../../services/user-messages.service';
import { QueryBuilder } from '../../services/query-builder.service';
import { LinkBuilder } from '../../services/link-builder.service';
import { TransportOperatorService } from '../../services/transport-operator/transport-operator.service';
import { TransportOperatorBusRouteService } from '../../services/transport-operator-route/transportOperatorRoute.service';
import { JourneyService } from '../../services/journey/journey.service';


export class ChargeAccountReplacedProductsTableController {
  public static $inject = [
    'usageEventProductMappingsService',
    'variantService',
    'productService',
    'paymentService',
    'UserMessages',
    'QueryBuilder',
    'LinkBuilder',
    '$rootScope',
    '$translate',
    'transportOperatorService',
    'transportOperatorBusRouteService',
    'journeyService'
  ];
  public currentLocale: string;
  public onReplacedProductSelected: Function;
  public usageEventProductMappings: Array<InterACT.Interfaces.UsageEventProductMappings.UsageEventProductMapping> = [];
  public replacementUsageEventProductMappingId: string;
  public chargeAccountId: string;
  public usageEventMappingToProductDictionary: InterACT.Interfaces.IDictionary<InterACT.Interfaces.Catalogues.Variant> = {};
  public usageEventProductMappingToPurchaseDateDictionary: InterACT.Interfaces.IDictionary<string> = {};
  public usageEventProductMappingToPaymentRequestDictionary: InterACT.Interfaces.IDictionary<InterACT.Interfaces.Payments.PaymentRequest> = {};
  public usageEventProductMappingToJourneyParamsDictionary: InterACT.Interfaces.IDictionary<InterACT.Interfaces.IJourneyParams> = {};
  public usageEventMappingToProductStartDateDictionary: InterACT.Interfaces.IDictionary<InterACT.Interfaces.IDictionary<string>> = {};
  public paginatorData: InterACT.Interfaces.IPaginationData = {
    currentPage: 0,
    perPageCount: 15,
    totalCount: 0
  };

  private readonly DEFAULT_MODE = 'any';

  constructor(
    private usageEventProductMappingsService: UsageEventProductMappingsService,
    private variantService: VariantService,
    private productService: ProductService,
    private paymentService: PaymentService,
    private userMessagesService: UserMessagesService,
    private queryBuilder: QueryBuilder,
    private linkBuilder: LinkBuilder,
    private $rootScope: InterACT.Interfaces.IActoraRootScope,
    private $translate: ng.translate.ITranslateService,
    private transportOperatorService: TransportOperatorService,
    private transportOperatorBusRouteService: TransportOperatorBusRouteService,
    private journeyService: JourneyService
  ) {
    this.activate();
  }

  /**
   * A method that is called during controller isntantiation
   */
  public activate() {
    this.currentLocale = this.$translate.use();
  }

  /**
   * Determines what icon should be shown based on the mode on a usage event product mapping
   *
   * @param usageEventProductMapping The usage event product mapping to get the mode for to determine what icon to use
   *
   * @returns a string representing the name of the icon to be used 
   */
  public getModeIcon(usageEventProductMapping: InterACT.Interfaces.UsageEventProductMappings.UsageEventProductMapping) {
    return this.usageEventProductMappingToJourneyParamsDictionary[usageEventProductMapping.id]
      ? this.usageEventProductMappingToJourneyParamsDictionary[usageEventProductMapping.id].mode.toLowerCase()
      : this.DEFAULT_MODE;
  }

  /**
   * A method that retrieves a product that has been linked to a supplied Usage Event Product Mapping
   * @param usageEventProductMapping the usage event product mapping to get the product for
   */
  public getProductForUsageEventProductMapping(usageEventProductMapping: InterACT.Interfaces.UsageEventProductMappings.UsageEventProductMapping) {
    const product = this.usageEventMappingToProductDictionary[usageEventProductMapping.id];

    if (!product) {
      return undefined;
    }

    return product;
  }

  /**
    * A method that retrieves a payment request that has been linked to a supplied journey
    * @param usageEventProductMapping the usageEventProductMapping to get the payment request for
    */
  public getPaymentRequestForUsageEventProductMapping(usageEventProductMapping: InterACT.Interfaces.UsageEventProductMappings.UsageEventProductMapping) {
    const paymentRequest = this.usageEventProductMappingToPaymentRequestDictionary[usageEventProductMapping.id];

    if (!paymentRequest) {
      return undefined;
    }

    return paymentRequest;
  }

  /**
 * A method that handles the case where a usage event product mapping row has been clicked on the UI
 * @param usageEventProductMapping the usageEventProductMapping that has been clicked
 */
  public onUsageEventProductMappingClicked = (usageEventProductMapping: InterACT.Interfaces.UsageEventProductMappings.UsageEventProductMapping) => {
    const usageEventProductMappingLink = this.linkBuilder.getUsageEventProductMappingLink(usageEventProductMapping.id);
    const query = this.queryBuilder.newParam().fieldIs('replacedBy.link', usageEventProductMappingLink).sortBy([{ columnName: 'created', direction: 'desc' }]).getParam();

    this.usageEventProductMappingsService.getList(1, 1, query).then((response) => {
      if (response.usageEventProductMappings.length === 0) {
        this.userMessagesService.showToast('NO_CHILD_PRODUCTS');
        return;
      }

      if (this.onReplacedProductSelected) {
        this.onReplacedProductSelected(usageEventProductMapping.id);
      }

      this.replacementUsageEventProductMappingId = usageEventProductMapping.id;
      this.getData(1, 15);
    });
  }

  /**
   * A method that returns a string of the direction of travel (DOT) if supplied or any otherwise
   * @param direction the DOT string to check
   */
  public getDirectionOfTravel(direction: string) {
    if (direction) {
      return 'ROUTE_DIRECTION.' + direction;
    }
    return 'ROUTE_DIRECTION.ALL';
  }

  /**
  * A method that retrieves a given page of journeys
  * @param page the page of journeys to retrieve
  * @param perPage the amount of journeys to retrieve per page
  */
  public getData(page: number, perPage: number) {
    let chargeAccountLink;
    let parentUsageEventProductMappingLink;
    let qParam;

    if (this.replacementUsageEventProductMappingId) {
      parentUsageEventProductMappingLink = this.linkBuilder.getUsageEventProductMappingLink(this.replacementUsageEventProductMappingId)
      qParam = this.queryBuilder.newParam().fieldIs('replacedBy.link', parentUsageEventProductMappingLink).sortBy([{
        columnName: 'created',
        direction: 'desc'
      }]).getParam();
    } else {
      chargeAccountLink = this.linkBuilder.getChargeAccountLink(this.chargeAccountId);
      qParam = this.queryBuilder.newParam().fieldIs('chargeAccount.link', chargeAccountLink).and().not().exists('replacedBy').sortBy([{
        columnName: 'created',
        direction: 'desc'
      }]).getParam();
    }

    if (!perPage) {
      perPage = this.paginatorData.perPageCount;
    }

    this.$rootScope.showSpinner = true;
    this.usageEventProductMappingsService.getList(page, perPage, qParam).then((response) => {
      this.paginatorData.totalCount = response.meta.totalCount;
      this.usageEventProductMappings = response.usageEventProductMappings.map((mapping) => {
        this.usageEventProductMappingToPurchaseDateDictionary[mapping.usageEventProductMapping.id] = <any>mapping.meta.created;
        return mapping.usageEventProductMapping;
      });

      this.populateUsageEventProductMappingToProductDictionary(this.usageEventProductMappings);
      this.populateUsageEventToPaymentRequestDictionary(this.usageEventProductMappings);
      this.populateUsageEventProductMappingToProductStartDate(this.usageEventProductMappings);
      this.$rootScope.showSpinner = false;
    });
  }

  /**
   * A method that gets the journey start date for a product. If a single product, we simply get the product start date on the product itself. If it is of any other type, we go and get the related items & fetch the start or end date or the returned journey.
   *
   * @param product The product we wish to get the journey start date for
   *
   * @returns The journey start date
   */
  private getJourneyStartDate = async (product: InterACT.Interfaces.UsageEventProductMappings.UsageEventProductMapping) => {
    let journeyDate;

    if (product) {
      if (product.productStartDate) {
        journeyDate = product.productStartDate;
      } else if (product.relatedItems && product.relatedItems.length > 0) {
        const journeyId = product.relatedItems[0].link.split('/').pop();
        const journeyResponse = <InterACT.Interfaces.Journeys.JourneyResponse>await this.journeyService.getJourney(journeyId);

        if (journeyResponse && journeyResponse.journey) {
          if (journeyResponse.journey.startDateTime) {
            journeyDate = journeyResponse.journey.startDateTime;
          } else if (journeyResponse.journey.endDateTime) {
            journeyDate = journeyResponse.journey.endDateTime;
          }
        }
      }

      return journeyDate;
    }
  }

  /**
* A method that populates the usage event product mappgings to product dictionary with entries for the supplied usage event product mapping
* @param id the id of the usage event product mapping to populate the dictionary with
*/
  private populateUsageEventProductMappingToProductDictionary(usageEventProductMappings: Array<InterACT.Interfaces.UsageEventProductMappings.UsageEventProductMapping>) {
    this.usageEventMappingToProductDictionary = {};

    for (let c = 0; c < usageEventProductMappings.length; c++) {
      const usageEventProductMapping = usageEventProductMappings[c];

      this.usageEventMappingToProductDictionary[usageEventProductMapping.id] = <any>{ name: '', description: '' };

      if (usageEventProductMapping.product) {
        /* If this mapping's product link refers to a catalogue resource, then use that resource for the product data to display.
         * Else, if this mapping has deserialised product data, use these fields for the product data to display.
         * This is required to support integration with Fujitu's Rail Fares Service (RFS), where the mapping's product link refers
         * to a product rated through the RFS rather than an ACT catalogue item. */
        if (usageEventProductMapping.product.link.match(/\/catalogues\/.*$/)) {
          this.getCatalogueItemForUsageEventProductMapping(usageEventProductMapping.product.link, usageEventProductMapping.id);
        } else if (usageEventProductMapping.product.productFields) {
          this.useDeserialisedProductData(usageEventProductMapping);
        }
      }
    }
  }

  private useDeserialisedProductData(productMapping: InterACT.Interfaces.UsageEventProductMappings.UsageEventProductMapping) {
    const productFields = productMapping.product.productFields;
    this.usageEventMappingToProductDictionary[productMapping.id] = <any>{
      name: productFields.name,
      description: productFields.description,
      fields: {
        direction: productFields.direction
      }
    };
    this.usageEventProductMappingToJourneyParamsDictionary[productMapping.id] = {
      service: productFields.services && productFields.services instanceof Array && productFields.services.length > 0
        ? (productFields.services.length === 1 ? productFields.services[0] : this.$translate.instant('MULTIPLE'))
        : this.$translate.instant('ROUTE_DIRECTION.ANY'),
      operator: productFields.operators && productFields.operators instanceof Array && productFields.operators.length > 0
        ? (productFields.operators.length === 1 ? productFields.operators[0] : this.$translate.instant('MULTIPLE'))
        : this.$translate.instant('ROUTE_DIRECTION.ANY'),
      mode: productFields.mode ? productFields.mode : this.$translate.instant('ROUTE_DIRECTION.ANY')
    };
  }

  /**
   * This method populates the usageEventMappingToProductStartDateDictionary with the journey start date. The start date logic is delegated to the getJourneyStartDate method which determines what fields to use and if a journey call needs to be made
   *
   * @param usageEventProductMappings The usageEventProductMappings we need to loop over and check for a start date
   */
  private populateUsageEventProductMappingToProductStartDate(usageEventProductMappings: InterACT.Interfaces.UsageEventProductMappings.UsageEventProductMapping[]) {
    for (let c = 0; c < usageEventProductMappings.length; c++) {
      const usageEventProductMapping = usageEventProductMappings[c];

      this.getJourneyStartDate(usageEventProductMappings[c]).then(journeyStartDate => {
        this.usageEventMappingToProductStartDateDictionary[usageEventProductMapping.id] = journeyStartDate;
      });
    }
  }

  /**
 * A method that gets the catalogue item for the supplied catalogue item id
 * @param link a link to the catalogue item to retrieve
 * @param usageEventProductMappingId the id of the usage event product mapping that this catalogue item is associated with
 */
  private getCatalogueItemForUsageEventProductMapping(link: string, usageEventProductMappingId: string, getJourneyParams: boolean = true) {
    const linkParts = link.split('/');
    const catalogueId = linkParts[2];
    const productId = parseInt(linkParts[4]);
    const variantIdWithQueryString = linkParts[6];
    const variantId = parseInt(variantIdWithQueryString.indexOf('?') !== -1 ? variantIdWithQueryString.split('?')[0] : variantIdWithQueryString);
    const catalogueVersion = variantIdWithQueryString.indexOf('?catalogueVersion=') !== -1 ? parseInt(variantIdWithQueryString.split('?catalogueVersion=')[1]) : null;

    return this.variantService.getVariant(catalogueId, productId, variantId, catalogueVersion).then((productVariant) => {
      this.usageEventMappingToProductDictionary[usageEventProductMappingId] = productVariant;

      if (getJourneyParams) {
        this.populateUsageEventProductMappingToJourneyParamsDictionary(usageEventProductMappingId, productVariant, productId, catalogueId, catalogueVersion);
      }

      return productVariant;
    });
  }

  /**
   * A method that populated the usageEventProductMappingToJourneyParams dictionary
   * @param uepmId the id of the usageEventProductmapping to usa as the dictionary key
   * @param productVariant the productvariant to use to check for journey params
   * @param productId the id of the product to retrieve should any journey params not exists on the product variant
   * @param catalogueId the id of the catalogue to retrieve the product from should any journey params not exists on the product variant
   */
  private populateUsageEventProductMappingToJourneyParamsDictionary(
    uepmId: string,
    productVariant: InterACT.Interfaces.Catalogues.Variant,
    productId: number,
    catalogueId: string,
    catalogueVersion?: number) {

    let parentProductRequired = false;
    const journeyParams: InterACT.Interfaces.IJourneyParams = {
      mode: this.$translate.instant('ROUTE_DIRECTION.ANY'),
      service: this.$translate.instant('ROUTE_DIRECTION.ANY'),
      operator: this.$translate.instant('ROUTE_DIRECTION.ANY')
    };

    this.usageEventProductMappingToJourneyParamsDictionary[uepmId] = journeyParams;

    if ((<any>(<any>productVariant.fields)).service) {
      this.setServiceOnJourneyParam(journeyParams, productVariant);
    } else {
      parentProductRequired = true;
    }

    if ((<any>productVariant.fields).mode) {
      journeyParams.mode = this.getJourneyParamAsString((<any>productVariant.fields).mode);
    } else {
      parentProductRequired = true;
    }

    if ((<any>productVariant.fields).operator) {
      this.setOperatorNameOnJourneyParam(journeyParams, productVariant);
    } else {
      parentProductRequired = true;
    }

    if (!parentProductRequired) {
      return;
    }

    this.setJourneyParamsUsingFieldsOnProduct(catalogueId, productId, journeyParams, catalogueVersion);
  }

  /**
   * A method that populates a journey params object using fields from a product.
   * The resultant object is then stored in a dictionary keyed on usage event product mapping id
   *
   * @param catalogueId The id of the catalogue that contains the product
   * @param productId the id of the product
   * @param journeyParams the journey params object to populate
   */
  private setJourneyParamsUsingFieldsOnProduct(
    catalogueId: string,
    productId: number,
    journeyParams: InterACT.Interfaces.IJourneyParams,
    catalogueVersion?: number) {
    this.productService.getProduct(catalogueId, productId, catalogueVersion ? { catalogueVersion: catalogueVersion } : undefined).then((product) => {
      if ((<any>product.fields).service) {
        this.setServiceOnJourneyParam(journeyParams, product);
      }

      if ((<any>product.fields).mode && (<any>product.fields).mode.length !== 0) {
        journeyParams.mode = this.getJourneyParamAsString((<any>product.fields).mode);
      }

      if ((<any>product.fields).operator) {
        this.setOperatorNameOnJourneyParam(journeyParams, product);
      }
    });
  }

  /**
 * A method that takes the route(s) from a product variant and sets the route on
 * a journey param object. The route on a product variant points to a trnaport operator service. We use the Reg number
 * to populate the route property here
 * @param journeyparam the journeyParam object to set the route property on
 * @param productVariant the product variant to get the service regNUmber from
 */
  private setServiceOnJourneyParam(journeyparam: InterACT.Interfaces.IJourneyParams, productVariant: InterACT.Interfaces.Catalogues.Product | InterACT.Interfaces.Catalogues.Variant) {
    if (!(<any>productVariant.fields).service) {
      return;
    }

    if ((<any>productVariant.fields).service instanceof Array) {
      if ((<any>productVariant.fields).service.length === 0) {
        return;
      }

      if ((<any>productVariant.fields).service.length > 1) {
        journeyparam.service = this.$translate.instant('MULTIPLE');
        return;
      }

      if (!(<any>productVariant.fields).service[0].link || (<any>productVariant.fields).service[0].link.length === 0) {
        return;
      }

      const serviceId = (<InterACT.Interfaces.Journeys.ServiceLink>(<any>productVariant.fields).service[0]).link.split('/').pop();
      this.queryBuilder.newParam().fieldIs('id', serviceId).getParam();
      this.transportOperatorBusRouteService.getTransportOperatorService(serviceId).then((response) => {
        if (response.registrationNumber) {
          journeyparam.service = response.registrationNumber + ' (' + response.serviceNumber + ')';
        } else {
          journeyparam.service = response.serviceNumber;
        }
      });

      return;
    }

    if (!(<any>productVariant.fields).service.link) {
      return;
    }

    const serviceId = (<InterACT.Interfaces.Journeys.ServiceLink>(<any>productVariant.fields).service).link.split('/').pop();
    this.queryBuilder.newParam().fieldIs('id', serviceId).getParam();
    this.transportOperatorBusRouteService.getTransportOperatorService(serviceId).then((response) => {
      journeyparam.service = response.serviceNumber;
    });
  }

  /**
   * A method that takes the operator(s) from a product variant and sets the corresponding name on
   * a journey param object.
   * @param journeyparam the journeyParam object to set the operator name on
   * @param productVariant the product variant to get the operator(s) from
   */
  private setOperatorNameOnJourneyParam(journeyparam: InterACT.Interfaces.IJourneyParams, productVariant: InterACT.Interfaces.Catalogues.Product | InterACT.Interfaces.Catalogues.Variant) {
    if (!(<any>productVariant.fields).operator) {
      return
    }

    if ((<any>productVariant.fields).operator instanceof Array) {
      if ((<any>productVariant.fields).operator.length === 0) {
        return;
      }

      if ((<any>productVariant.fields).operator.length > 1) {
        journeyparam.operator = this.$translate.instant('MULTIPLE');
        return;
      }


      if (!(<any>productVariant.fields).operator[0].link || (<any>productVariant.fields).operator[0].link.length === 0) {
        return;
      }

      const operatorId = (<InterACT.Interfaces.TransportOperatorServices.OperatorLink>(<any>productVariant.fields).operator[0]).link.split('/').pop();
      this.queryBuilder.newParam().fieldIs('id', operatorId).getParam();
      this.transportOperatorService.getOperator(operatorId).then((response) => {
        journeyparam.operator = response.name[this.currentLocale];
      });

      return;
    }

    if (!(<any>productVariant.fields).operator.link) {
      return;
    }

    const operatorId = (<InterACT.Interfaces.TransportOperatorServices.OperatorLink>(<any>productVariant.fields).operator).link.split('/').pop();
    this.queryBuilder.newParam().fieldIs('id', operatorId).getParam();
    this.transportOperatorService.getOperator(operatorId).then((response) => {
      journeyparam.operator = response.name[this.currentLocale];
    });

    return;
  }

  /**
   * A method that converts a journeyParam into a string if it is an Array, if the Array has more than one element it returns "Multiple"
   * @param param the journeyParam to convert into a string
  */
  private getJourneyParamAsString = (param: string | Array<string>) => {
    if (param instanceof Array) {
      if (param.length > 1) {
        return this.$translate.instant('MULTIPLE');
      } else {
        return param.toString();
      }
    } else {
      return param;
    }
  };

  /**
   * A method that populates the usage event product mappings to payment requests dictionary with entries for the supplied usage event product mappings
   * @param usageEvents the usage event product mappings to get the payment requests for
   */
  private populateUsageEventToPaymentRequestDictionary(usageEvents: Array<InterACT.Interfaces.UsageEventProductMappings.UsageEventProductMapping>) {
    for (let i = 0; i < usageEvents.length; i++) {
      this.retrievePaymentRequestAndStoreInDictionary(usageEvents[i].id);
    }
  }

  /**
   * a method that populates the usage event product mapping to payment request dictionary
   * @param usageEventProductMappingId the id of the usage event product mapping to get the payment request for
   */
  private retrievePaymentRequestAndStoreInDictionary(usageEventProductMappingId: string) {
    const usageEventProductMappingLink = this.linkBuilder.getUsageEventProductMappingLink(usageEventProductMappingId);
    const query = this.queryBuilder.newParam().fieldIs('items', usageEventProductMappingLink).getParam();

    this.paymentService.getPaymentHistory(1, 1, query).then((response) => {
      for (let c = 0; c < response.paymentRequests.length; c++) {
        const paymentRequest = response.paymentRequests[c];
        this.usageEventProductMappingToPaymentRequestDictionary[usageEventProductMappingId] = paymentRequest;
      }
    });
  }
}
